import { react, useEffect } from 'react';
import { test } from './utils/MIDIPlayer.ts';
import { createLogger } from './utils/logger';

const log = createLogger('midi-test');

const MIDITest = () => {
  useEffect(() => {
    test()
    .then(() => log.info('notes scheduled'))
    .catch((error) => log.error('error scheduling notes', error));
    log.info('started');
  }, []);
  
  return <div />;
};

export default MIDITest;


